import { GetterTree } from 'vuex'
import { SeasonModule } from '..'
import { BBTreeviewNode } from '../../types'
import { toFilterSets } from '../../utils/filters/filters.generics'

export const getters: GetterTree<typeof SeasonModule['state'], unknown> = {
  seasonsAsTreeNodes(state): BBTreeviewNode {
    return {
      name: 'Season',
      id: 'all_seasons',
      groupingKey: 'season',
      type: 'Checkbox',
      children: [
        ...toFilterSets(state.all, season => {
          return {
            id: season._id,
            value: season._id,
            name: season.name,
            groupingKey: 'season',
            type: 'Checkbox'
          }
        }),
        {
          id: 'season_not_set',
          name: 'Not Set',
          value: null,
          groupingKey: 'season',
          type: 'Checkbox'
        }
      ]
    }
  }
}
